// extracted by mini-css-extract-plugin
export default {"mainContainer":"verify-code-module--mainContainer--CZ1FF","codeInput":"verify-code-module--codeInput--qq+0E","codeImg":"verify-code-module--codeImg--dlONC"};